// This is legacy file. It was used before app #8.  Starting app #8, products.products is used
import { make } from 'vuex-pathify'
import rpc from '../../api/rpc'
import Notify from 'quasar/src/plugins/Notify.js';
import getSessionContext from 'src/utils/context/getSessionContext'

const state = {
  currentOrg: null,
  availableOrgs: null,
  availableOrgsAsTree: null
}

const mutations = make.mutations(state)
const namespaced = true

const getters = {
  currentOrgObj: state => (state.availableOrgs || []).find(r => r.id === state.currentOrg) || {},
  topLevelAvailableOrgs: state => {
    if (!state.availableOrgs || state.availableOrgs.length === 0) return []
    return state.availableOrgs.filter(r => !(state.availableOrgs || []).some(r2 => r2.id === r.parent_id))
  }
}

const actions = {
  async availableOrgsAsTreeFetch ({ commit, rootState }, params) {
    const response = await rpc('orgs.orgs_fetch_as_tree', { app_id: rootState.authorizedUser.currentAppObject.id, org_id: rootState.ors.currentOrg, role_id: params.role_id, on_behalf_of_org_id: params.on_behalf_of_org_id })
    if (response) {
      commit('SET_AVAILABLE_ORGS_AS_TREE', response)
      return true
    }
  },

  setCurrentOrg ({ commit, dispatch, rootState }, val) {
    localStorage.setItem('lastSelectedOrgId', val)
    commit('SET_CURRENT_ORG', val)
    dispatch('products/setProducts', null, { root: true })
    dispatch('trees/setTrees', null, { root: true })

    if (rootState.authorizedUser.currentAppObject.id === 4) {
      dispatch('suppliers/supplierTypesFetch', null, { root: true })
    }
    if (rootState.authorizedUser.currentAppObject.id === 3) {
      dispatch('products/productsFetch', { org_id: getSessionContext().org_id, app_id: rootState.authorizedUser.currentAppObject.id }, { root: true })
      dispatch('trees/treesFetch', { org_id: getSessionContext().org_id, app_id: rootState.authorizedUser.currentAppObject.id }, { root: true })
    }
  },

  setCurrentOrgFromLastSelectedOrDefault ({ dispatch, state, getters }) {
    const lastSelected = localStorage.getItem('lastSelectedOrgId')
    if (lastSelected && state.availableOrgs.map(r => r.id).includes(lastSelected)) {
      dispatch('setCurrentOrg', lastSelected)
    } else {
      const topLevelAvailableOrgs = getters['topLevelAvailableOrgs']
      if (topLevelAvailableOrgs.length === 0) {
        Notify.create({ message: 'Your role has access to this app, but no org level permissions have been assigned', color: 'negative' })
      } else {
        dispatch('setCurrentOrg', topLevelAvailableOrgs[0].id)
        return true
      }
    }
  }
}

export default { state, mutations, namespaced, actions, getters }
